import { AfterViewInit, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Path } from 'src/app/util/path';

@Component({
    selector: 'app-mapa-site',
    templateUrl: './mapa-site.component.html',
    styleUrls: ['./mapa-site.component.scss'],
    standalone: false
})
export class MapaSiteComponent implements OnInit, AfterViewInit {
  path = Path

  @Output() mapaEvent = new EventEmitter<boolean>();
  constructor() { }

  ngAfterViewInit(): void {
    document.getElementById("mapa")?.scrollIntoView({behavior: "smooth"})
  }

  public mostrarMapa(){
    this.mapaEvent.emit(false);
  }

  ngOnInit(): void {
    
  }

}
